import React from 'react';

import { formatInTimeZone } from '@/components/NewUI/utils/dateTime';
import dayjs, { preferredTimeZone } from '@/components/NewUI/utils/dayjs';
import { fromZonedWallClock } from '@/components/NewUI/utils/zonedWallClock';

const FormattedDate = ({ date }: { date: string }) => {
  const parsed = dayjs(date);
  const datePart = /^\d{4}-\d{2}-\d{2}/.exec(date)?.[0];
  const validCalendarDate = !datePart || dayjs(datePart, 'YYYY-MM-DD', true).isValid();
  const formatted =
    parsed.isValid() && validCalendarDate
      ? formatInTimeZone(
          /([zZ]|[+-]\d{2}:?\d{2})$/.test(date)
            ? parsed
            : dayjs(fromZonedWallClock(dayjs.utc(date), preferredTimeZone)),
          preferredTimeZone,
          'DD MMM YYYY,-h:mma z'
        )
      : 'Invalid date';
  return (
    <>
      {formatted.split('-').map((line) => (
        <span key={line}>{line}</span>
      ))}
    </>
  );
};

export default FormattedDate;
